import { Component } from '@angular/core';

import { PasskeyLoginErrorService } from './passkey-login-error.service';

@Component({
    standalone: false,
    selector: 'ycn-passkey-login-error',
    templateUrl: './passkey-login-error.template.html',
})
export class PasskeyLoginErrorComponent {
    errorMessage = this.passkeyLoginErrorService.errorMessage;

    constructor(private passkeyLoginErrorService: PasskeyLoginErrorService) {}
}
